import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useBrand } from '@aviv-unified-frontend/runtime/brand';
import { Box } from '@gemini/core';
import { Divider as GeminiDivider } from '@gemini/ui';
import { useBrandConfiguration } from '../../brands/context';
import { useSerpTranslation } from '../../hooks/useI18n';
import { AutoPromo } from './AutoPromo/AutoPromo';
export const AutopromoListTestId = 'serp-core-autopromo-list-testId';
export const AutopromoListDividerTestId = 'serp--core-autopromo-divider-testId';
const Divider = () => (_jsx(Box, { display: {
        'breakpoint.base': 'none',
        'breakpoint.md': 'flex',
    }, testId: AutopromoListDividerTestId, children: _jsx(GeminiDivider, {}) }));
export const AutoPromoList = () => {
    const { createUrl } = useBrand();
    const brandConfig = useBrandConfiguration();
    const autoPromos = brandConfig?.autoPromo?.autoPromos || [];
    const { t } = useSerpTranslation();
    if (!autoPromos.length) {
        return null;
    }
    const shouldForceHorizontalDisplay = autoPromos.length === 1;
    const autoPromoList = autoPromos.map(({ type, image, callToActionLink }) => ({
        title: t(`autopromo.${type}.title`),
        description: t(`autopromo.${type}.description`),
        callToActionText: t(`autopromo.${type}.cta`),
        callToActionLink,
        image: createUrl(image).toString(),
        display: shouldForceHorizontalDisplay ? 'horizontal' : 'vertical',
    }));
    return (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx(Box, { display: "flex", gap: "spacing.24", flexDirection: { 'breakpoint.base': 'column', 'breakpoint.md': 'row' }, testId: AutopromoListTestId, children: autoPromoList.map((autoPromoProps) => (_jsx(AutoPromo, { ...autoPromoProps }, autoPromoProps.title))) }), _jsx(Divider, {})] }));
};
